module.exports = __webpack_public_path__ + "static/img/Thomas-Duffy.d089f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Duffy.jpg
// module id = 2dFG
// module chunks = 0